import { createRouter, createWebHashHistory } from "vue-router";
import LoginView from "../views/LoginView.vue";

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginView,
  },
  {
    path: "/home",
    name: "home",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeView.vue"),
  },
  {
    path: "/landing",
    name: "landing",
    component: () => import("../views/LandingPageView.vue"),
  },
  {
    path: "/submissions",
    name: "submissions",
    component: () => import("../views/SubmissionsView.vue"),
  },
  {
    path: "/submission",
    name: "submission",
    component: () => import("../views/SubmissionView.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
